import type { ReactElement } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@-/dev.improve.haniverse.components.ui.dropdown-menu";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import type { AdminPanelPlacement } from "#admin-panel-layout";

/**
 * The panel's More menu on Android and web, drawn by the shared JS dropdown. iOS uses the system
 * menu instead (`admin-panel-more-menu.ios.tsx`).
 */
export function AdminPanelMoreMenu({
  onClose,
  onPlacementChange,
  placement,
  trigger,
}: {
  onClose: () => void;
  onPlacementChange: (placement: AdminPanelPlacement) => void;
  placement: AdminPanelPlacement;
  trigger: ReactElement;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="min-w-48"
        side={placement === "top" ? "bottom" : "top"}
        sideOffset={8}
      >
        <DropdownMenuItem
          onPress={() => onPlacementChange(placement === "top" ? "bottom" : "top")}
          testID="admin-panel-move"
        >
          <Text>{placement === "top" ? "Move to Bottom" : "Move to Top"}</Text>
        </DropdownMenuItem>
        <DropdownMenuItem onPress={onClose} testID="admin-panel-close">
          <Text>Close Admin Panel</Text>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
